import styled from "@emotion/styled";

import { BaseLink } from "shared/components/common/base-link";
import { fontBarlowSemiCondensed, fontRoboto, theme } from "shared/lib/styles";

import { StyleSitemap } from "./sitemap";
import { StyleSocialMedia } from "./social-media";

export const Container = styled.div`
  padding-block: 48px 24px;

  background: #222222;

  ${theme.breakpoints.up("tablet")} {
    padding-block: 48px;
  }
`;

export const Wrapper = styled.div`
  display: grid;
  grid-auto-flow: column;
  grid-template:
    "logo"
    "social"
    "sitemap"
    "link"
    "foot";
  grid-row-gap: 48px;
  justify-items: center;

  max-inline-size: 335px;
  margin-inline: auto;

  ${theme.breakpoints.up("tablet")} {
    grid-template: "logo social" 74px "logo sitemap" max-content "foot foot";
    grid-row-gap: 16px;
    justify-items: unset;

    max-inline-size: 688px;
  }

  ${theme.breakpoints.up("desktop")} {
    max-inline-size: 928px;
  }

  ${theme.breakpoints.up("mediumDesktop")} {
    max-inline-size: 1184px;
  }
`;

export const LogoStyleContainer = styled(BaseLink)`
  grid-area: logo;

  display: flex;
  flex-direction: column;
  align-items: center;

  ${theme.breakpoints.up("tablet")} {
    justify-self: start;
    align-items: start;
  }
`;

export const DownloadAppLink = styled.a`
  grid-area: link;

  padding-block: 8px;
  padding-inline: 16px;

  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  font-family: ${fontBarlowSemiCondensed};
  letter-spacing: 1.4px;

  border: 0.5px solid #ffffff;
  border-radius: 3px;

  ${theme.breakpoints.up("tablet")} {
    display: none;
  }
`;

export const LogoSCMPContainer = styled(BaseLink)`
  grid-area: logo-scmp;
`;

export const StyledStyleSitemap = styled(StyleSitemap)`
  grid-area: sitemap;

  padding-inline: 20px;

  ${theme.breakpoints.up("tablet")} {
    justify-self: end;

    padding-inline: 0;
  }
`;

export const Footer = styled.div`
  grid-area: foot;

  display: grid;
  grid-template-areas:
    "logo-scmp"
    "copyright";
  grid-row-gap: 16px;
  justify-items: center;

  ${theme.breakpoints.up("tablet")} {
    grid-template-areas: "logo-scmp copyright";
    justify-items: unset;

    padding-block-start: 40px;
  }
`;

export const Copyright = styled.div`
  grid-area: copyright;

  color: #bbbbbb;
  font-weight: 400;
  font-size: 9px;
  font-family: ${fontRoboto};
  letter-spacing: -0.24px;

  ${theme.breakpoints.up("tablet")} {
    justify-self: end;

    font-size: 12px;
  }
`;

export const StyledStyleSocialMedia = styled(StyleSocialMedia)`
  grid-area: social;
  ${theme.breakpoints.up("tablet")} {
    justify-self: end;

    inline-size: 116px;
  }
`;
